const personCircles = document.querySelectorAll('.intra-banner__person-circle');

personCircles.forEach((personCircle) => {
  personCircle.addEventListener('click', () => {
    const dropdown = personCircle.querySelector('.intra-banner__person-dropdown');
    personCircle.classList.toggle('is-active');
    dropdown.classList.toggle('is-active');
  });
});
